import { render, staticRenderFns } from "./BgLayerSwitcher.vue?vue&type=template&id=36e0dada&scoped=true&"
import script from "./BgLayerSwitcher.vue?vue&type=script&lang=js&"
export * from "./BgLayerSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BgLayerSwitcher.vue?vue&type=style&index=0&id=36e0dada&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0dada",
  null
  
)

export default component.exports